import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestSettings = {
    path: "/settings",
    method: RouteHttpVerb.GET
};
export { locationRestSettings };
